module.exports = __webpack_public_path__ + "img/2.dacadb7a.jpg";